// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list","962":"home"}[chunkId] || chunkId) + "-" + {"137":"8f1952ff70d3f8ea3634","702":"242ee1f2d5b45a575f7d","715":"c4cf09cc637e4ae438a8","796":"c2f878543e210e1d2dc5","962":"ed1bd608ffaf5831a014"}[chunkId] + ".css";
};